module.exports = __webpack_public_path__ + "img/es-ca.e9062265.svg";